import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = ({loading}) => {
  if (!loading) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" my={5}>
      <CircularProgress color="secondary" />
    </Box>
  );
};

export default Loading;
